import { Box, Icon } from '@ecoinvent/ui';
import { IconType } from 'react-icons';
import { FiGlobe } from 'react-icons/fi';
import { GrCubes } from 'react-icons/gr';
import { HiHome } from 'react-icons/hi';
import { IoArchiveOutline, IoCube, IoInvertModeSharp } from 'react-icons/io5';

import { FlowType } from 'hooks/data/datasets/V4/flows/types';

const BADGE_COLORS = {
  badgeTransformingBg: '#D0F3E1',
  badgeTransformingIcon: '#2EA266',
  badgeImportMixBg: '#B2F5EA',
  badgeImportMixIcon: '#319795',
  badgeDomesticMixBg: '#E9D8FD',
  badgeDomesticMixIcon: '#805AD5',
  badgeConsumptionMixBg: '#C3CBF4',
  badgeConsumptionMixIcon: '#3F59DC',
  badgeGlobalMixBg: '#FED7E2',
  badgeGlobalMixIcon: '#D53F8C',
};

export type ProcessTypeBadgeStyle = {
  bg: string;
  iconColor: string;
  icon: IconType;
  subIcon?: IconType;
};

export const PROCESS_TYPE_BADGE_STYLES: Record<FlowType, ProcessTypeBadgeStyle> = {
  'Transforming activity': {
    bg: BADGE_COLORS.badgeTransformingBg,
    iconColor: BADGE_COLORS.badgeTransformingIcon,
    icon: IoCube,
  },
  'Import mix': { bg: BADGE_COLORS.badgeImportMixBg, iconColor: BADGE_COLORS.badgeImportMixIcon, icon: IoArchiveOutline },
  'Domestic supply mix': {
    bg: BADGE_COLORS.badgeDomesticMixBg,
    iconColor: BADGE_COLORS.badgeDomesticMixIcon,
    icon: HiHome,
    subIcon: GrCubes,
  },
  'Consumption mix': {
    bg: BADGE_COLORS.badgeConsumptionMixBg,
    iconColor: BADGE_COLORS.badgeConsumptionMixIcon,
    icon: IoInvertModeSharp,
  },
  'Global supply mix': {
    bg: BADGE_COLORS.badgeGlobalMixBg,
    iconColor: BADGE_COLORS.badgeGlobalMixIcon,
    icon: FiGlobe,
    subIcon: GrCubes,
  },
};

const FALLBACK_BADGE: ProcessTypeBadgeStyle = { bg: 'gray.100', iconColor: 'gray.600', icon: IoCube };

export const getProcessTypeBadgeStyle = (type: string): ProcessTypeBadgeStyle =>
  PROCESS_TYPE_BADGE_STYLES[type as FlowType] ?? FALLBACK_BADGE;

type ProcessTypeIconProps = {
  icon: IconType;
  subIcon?: IconType;
  boxSize?: string | number;
  subBoxSize?: string | number;
  subOffset?: string | number;
};

const ProcessTypeIcon = ({ icon, subIcon, boxSize = '14px', subBoxSize = '6px', subOffset = 0 }: ProcessTypeIconProps) => (
  <Box position="relative" boxSize={boxSize} flexShrink={0} lineHeight={0}>
    <Icon as={icon} boxSize={boxSize} display="block" />
    {subIcon && (
      <Icon as={subIcon} boxSize={subBoxSize} display="block" position="absolute" top={subOffset} right={subOffset} />
    )}
  </Box>
);

export default ProcessTypeIcon;
